import { render, staticRenderFns } from "./SupportFooter.vue?vue&type=template&id=3ccbdb22&scoped=true"
import script from "./SupportFooter.vue?vue&type=script&lang=js"
export * from "./SupportFooter.vue?vue&type=script&lang=js"
import style0 from "./SupportFooter.vue?vue&type=style&index=0&id=3ccbdb22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccbdb22",
  null
  
)

export default component.exports